'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var magicCommon = require('@gig/magic-common');
var magicFormBuilder = require('@gig/magic-form-builder');

function addressAutocomplete() {
    return {
        id: 'address',
        component: 'magic-ui-address-autocomplete-field',
        isDataField: true,
        testId: 'step2-address',
        properties: {
            placeholder: magicCommon.translate('sign-up-step-two.address.placeholder'),
            name: 'address',
            ref: 'address',
        },
        emitHandlers: {
            'apply-address': function ($event) {
                var address = $event.detail[0];
                return {
                    id: 'address',
                    value: address,
                    isValid: address ? true : false,
                    touched: false,
                };
            },
            'apply-city': function ($event) {
                var city = $event.detail[0];
                return {
                    id: 'city',
                    value: city,
                    isValid: city ? true : false,
                    touched: false,
                };
            },
            'apply-postcode': function ($event) {
                var postcode = $event.detail[0];
                return {
                    id: 'postcode',
                    value: postcode,
                    isValid: postcode ? true : false,
                    touched: false,
                };
            },
            'apply-province': function ($event) {
                var state = $event.detail[0];
                return {
                    id: 'province',
                    value: state,
                    isValid: state ? true : false,
                    touched: false,
                };
            },
            'apply-country': function ($event) {
                var country = $event.detail[0];
                return {
                    id: 'country',
                    value: country,
                    isValid: country ? true : false,
                    touched: false,
                };
            },
        },
        validation: [
            {
                name: 'required',
                fn: magicFormBuilder.required,
                message: magicCommon.translate('sign-up-step-two.address.required-error'),
            },
            {
                name: 'min-length',
                fn: magicFormBuilder.minLength(3),
                message: magicCommon.translate('sign-up-step-two.address.min-length-error'),
            },
        ],
        converter: function (formValue) {
            return {
                address1: formValue.address.value,
            };
        },
    };
}

exports.addressAutocomplete = addressAutocomplete;
